import { render, staticRenderFns } from "./DialogCookiesDelete.vue?vue&type=template&id=2b104f75&"
import script from "./DialogCookiesDelete.vue?vue&type=script&lang=js&"
export * from "./DialogCookiesDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports